/*
  Project: Fideltronik
  Author: Adrian
 */

import Glide from '@glidejs/glide';

if (document.querySelector('.glide')) {
  const glide = new Glide('.glide', {
    type: 'carousel',
    startAt: 1,
    perView: 3,
    gap: 20,
    focusAt: 'center',
  });

  glide.mount();
}



// WEBPACK FOOTER //
// ./src/scripts/app.js